import HeaderTabBasketView from './HeaderTabBasketView';
import HeaderTabView from './HeaderTabView';
import $ from 'jquery';
import SharedDispatcher from '../others/SharedDispatcher';
import getTabContent from '../../api/headerTab/getTabContent.js';

export default class {
  _open = false;
  _currentTab = null;
  _tabContent = null;
  _style = null;
  _opener = null; // used to update pointer/arrow style

  constructor({ el }) {
    this.el = el;
    this._handleTabButtonClick = this._handleTabButtonClick.bind(this);
    this._close = this._close.bind(this);
    this._updateLayoutHeaderPosition = this._updateLayoutHeaderPosition.bind(this);

    this._tabContent = this.el.querySelector('.js-HeaderTab-content');

    SharedDispatcher.on('overlay:click', this._close);
    SharedDispatcher.on('header-tab:close', this._close);
    SharedDispatcher.on('history:show', this._close);
    this._injectTabPositionStyleSheet();
    // Update shutter style rules (the only way to update styles of pseudo elements)
    window.addEventListener('resize', this._updateLayoutHeaderPosition); // update layout when resize
    this.el.addEventListener('click', this._handleTabButtonClick);
  }

  // We need to inject a style element then control CSS rules to update position of shutters based on related "tab=top" buttons. We can't use the style property directly be cause we have to target pseudo elements too
  _injectTabPositionStyleSheet() {
    this._style = document.createElement('style');
    this._style.textContent = `.js-HeaderTab-content::after{/*New header shutters layout, updated dynamically*/}`;
    document.head.appendChild(this._style);
  }

  _updateLayoutHeaderPosition() {
    if (!this._opener) {
      return;
    }

    const shutterWidth = 320;
    const borderOffset = 20;
    const [{ style }] = this._style.sheet.cssRules;
    const viewportWidth = document.documentElement.offsetWidth; // layout viewport width (without scrollbar)
    // Note: https://www.quirksmode.org/mobile/viewports2.html https://www.quirksmode.org/mobile/viewports/

    const { left, width } = this._opener.getBoundingClientRect();
    // assume shutter width=shutterWidth, right>=borderOffset
    const tabCenter = left + width / 2;
    const shutter = Math.min(tabCenter - shutterWidth / 2, viewportWidth - shutterWidth - borderOffset);
    const arrowCenter = tabCenter - shutter;
    // Shutter rule
    this._tabContent.style.left = `${shutter}px`;
    // Arrow rule
    style.cssText = `left: ${arrowCenter}px !important`;
  }

  _updateSidebarZIndex() {
    $('.js-SlideNav-toggler').toggleClass('isAbove', this._open);
    $('.js-Sidebar').toggleClass('isAbove', this._open);
    $('.SlideNav').toggleClass('isAbove', this._open);
  }

  _close() {
    this._open = false;
    this._opener = null;

    this._tabContent.classList.remove('open');
    SharedDispatcher.trigger('overlay:hide');
    this._updateSidebarZIndex();

    this._currentTab?.remove();
    this._currentTab = null;
  }

  _handleTabButtonClick(e) {
    const target = e.target.closest('.js-HeaderTab-toggle');

    if (!target) {
      return;
    }

    e.preventDefault();
    SharedDispatcher.trigger('sidebar:hide');

    // Switch to a other tab
    if (this._currentTab) {
      this._currentTab.remove();
    } else {
      this._tabContent.classList.add('open');
      SharedDispatcher.trigger('overlay:show', { cssModifier: 'header-layers', noSpinner: true });
      this._updateSidebarZIndex();
    }

    const name = target.dataset.headerTab;

    if (this._currentTab?.name === name) {
      this._close();
      return;
    }

    const tab =
      name === 'basket'
        ? new HeaderTabBasketView()
        : new HeaderTabView({ name, fetch: () => getTabContent({ type: name }) });

    this._currentTab = tab;
    this._tabContent.appendChild(tab.el);
    this._opener = target;
    this._updateLayoutHeaderPosition();
    this._currentTab.load();
  }
}
